import { useMediaQuery } from "@mui/material";
import WebView from "./BankWebView";
import MobileView from "./BankMobileView";
export default function Bank() {
  const isSmallScreen = useMediaQuery("(max-width:800px)");
  return <>{isSmallScreen ? <MobileView /> : <WebView />}</>;
}
